export const PAGE_SIZE = 50;
export const SEARCH_FIELD_LABEL = 'Search by Customer ID or Customer Name';

export const userSelectedInitialState = {
    selectedAccount: {
        opcoId: null,
        customerId: null,
        accountId: null,
        accountType: null,
        name: null,
    },
    errorMessage: null,
    includeInactives: false,
};
